import FlatObjectAccessor from "@/utils/moreMenu/FlatObjectAccessor.ts";
import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import BaseDispatcher from "@/utils/presenters/BaseDispatcher.ts";
import NaMaMetaData = namaTypes.NaMaMetaData;
import ListOfGenericValues = namaTypes.ListOfGenericValues;
import GenericValue = namaTypes.GenericValue;

export default abstract class ActionPerformerHelper
{
  abstract fetchPresenter(): WidgetsPresenter;

  abstract addContextFieldsToAction(contextFieldIds: string[], contextRow: number, contextFields: Record<string, GenericValue>): void;

  abstract getEntityType(): string;

  editViewName(): string | undefined {
    return undefined;
  };

  listViewName(): string | undefined {
    return undefined;
  };

  abstract entityMetadata(): NaMaMetaData;

  onGuiActionUpdateList(updateList: ListOfGenericValues | undefined, contextRow?: number) {
  };

  getAccessor(): FlatObjectAccessor | null {
    return null;
  }

  beforeGoToPlace(): void {
  }

  async refresh(doNotHideErrors: boolean, doNotHideWarnings: boolean) {
  }

  updateRelatedFields(result: ListOfGenericValues, row: number): boolean {
    return false;
  };

  getSearchAndSuggestionsProvider(): BaseDispatcher | null {
    return null;
  };
}
